import { memo } from 'react';
import { useApplySavedSearch } from './use-apply-saved-search';

/**
 * Headless mount point for `useApplySavedSearch`. Rendered once inside the search
 * layout (within scope + router context) so a `?saved-search=` link is applied to
 * the params store on load.
 */
export const SavedSearchLoader = memo(() => {
  useApplySavedSearch();
  return null;
});

SavedSearchLoader.displayName = 'SavedSearchLoader';
